import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';

import { __t, applyTranslations } from 'utils/language';
import { copyTextToClipboard } from 'utils/helper/common';

applyTranslations(require('./deliverable-info-copy-control.i18n.json'));

type Props = {
  uniqueKey: string,
  wrapperClass: string
}

const DeliverableInfoCopyControl = ({ uniqueKey, wrapperClass }: Props) => {
  const handleCopy = (event: React.SyntheticEvent<HTMLElement>) => {
    const target = event.currentTarget;

    copyTextToClipboard(`[data-copy-key="${target.dataset.keyToCopy}"]`);
  };

  return (
    <Tooltip
      message={__t('deliverable_info_copy_control.action_button_copy')}
      width="micro"
      classNameWrapper={wrapperClass}
    >
      <div>
        <Tooltip
          message={__t('deliverable_info_copy_control.copied')}
          width="micro"
          trigger="click"
        >
          <SVGDynamicIcon
            height={16}
            width={16}
            name="duplicate-custom-fg"
            customColor="grey"
            data={{ 'key-to-copy': `${uniqueKey}-field-to-copy` }}
            onClick={handleCopy}
          />
        </Tooltip>
      </div>
    </Tooltip>
  );
};

export default DeliverableInfoCopyControl;
